import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import User from '../../models/user';

const initialState: User = {
    id: null,
    firstName: null,
    lastName: null,
    accountType: null,
};

export const userSlice = createSlice({
    name: 'user',
    initialState: initialState,
    reducers: {
        setUser: (state, action: PayloadAction<User>) => {
            state.id = action.payload.id;
            state.firstName = action.payload.firstName;
            state.lastName = action.payload.lastName;
            state.accountType = action.payload.accountType;
            state.instructorId = action.payload.instructorId;
        },
    },
});

// Action creators are generated for each case reducer function
export const { setUser } = userSlice.actions;

export default userSlice.reducer;
